import { Book } from '@apis/index'
import BackNavigation from '@components/backNavigation'
import ImageGallery from '@components/image/imgaeGallery'
import { Actions, store } from '@store/index'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import BookDescriptionLoader from '../home/loader/bookDescriptionLoader'
import {
  AuthorName,
  BookCategory,
  BookContent,
  BookDescriptionTitle,
  BookDetails,
  BookTitle,
  Description,
  FormWrapper,
  StyleFixedButton,
} from './style'
import useWindowSize from '@hooks/useWindow'
import Button from '@components/button'

const ViewMyBooks = () => {
  const { width } = useWindowSize()
  const { id } = useParams()
  const navigate = useNavigate()

  const fetchBook = async () => {
    try {
      await Book.getBook(id)
    } catch (error) {
      console.error('Error fetching book:', error)
    }
  }
  const { data: book, loading: fetching } = useSelector(
    (state: any) => state.book,
  )
  useEffect(() => {
    if (!book.id) {
      fetchBook()
    }
    return () => {
      store.dispatch(Actions.reset('book'))
    }
  }, [id])
  const restImages = book?.additionalImages
    ? book?.additionalImages?.map((item) => {
        return item?.images
      })
    : []
  const mobile = width < 1024
  const renderButton = () => (
    <Button
      title={'Own Book'}
      type="button"
      disabled
      height={40}
      styleButtonWrapper="margin-top:auto"
    />
  )
  return (
    <>
      <BackNavigation
        title="Home"
        onClick={() => {
          navigate('/books')
        }}
      />

      <FormWrapper style={{ margin: '10px 0' }}>
        {!!fetching && <BookDescriptionLoader />}
        {!fetching && (
          <BookContent>
            <BookDetails>
              <ImageGallery images={[book.coverImage, ...restImages]} />
            </BookDetails>

            <BookDetails>
              <BookTitle>{book?.name}</BookTitle>
              <div style={{ display: 'flex', gap: '10px' }}>
                <BookCategory>{book?.categoryData?.name}</BookCategory>
                <AuthorName>{book?.author}</AuthorName>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <BookDescriptionTitle>Description</BookDescriptionTitle>
                <Description>{book?.description}</Description>
              </div>
              {!mobile ? (
                renderButton()
              ) : (
                <StyleFixedButton>{renderButton()}</StyleFixedButton>
              )}
            </BookDetails>
          </BookContent>
        )}
      </FormWrapper>
    </>
  )
}

export default ViewMyBooks
